import { ModelInputs } from "./types";
import { numOrUndef, prune, toIsoDateOrUndef } from "./utils";

export type ProjectCreatePayload = {
  customer_id?: string;
  project_name?: string;

  latitude?: number;
  longitude?: number;
  state?: string;
  county?: string;
  city?: string;
  zip_code?: string;
  timezone?: string;

  project_nerc_code?: string;
  eia_ba_code?: string;

  cod_date?: string;
  decommision_date?: string;

  nameplate_capacity?: number;
  poi_limit?: number;
  project_additional_load?: number;

  ppa_flag?: boolean;
  ppa_percentage?: number;
  ppa_capacity?: number;

  battery_flag?: boolean;
  battery_capacity_mwh?: number;
  battery_charge_rate_mw?: number;
  battery_discharge_rate_mw?: number;
  battery_round_trip_eff?: number;
  battery_soc_min?: number;
  battery_chemistry?: string;
  battery_calendar_life_years?: number;
  battery_cycle_life?: number;
  battery_augmentation_flag?: boolean;
  battery_depth_of_discharge?: number;

  tech_type_id?: string;
  existing_project_flag?: boolean;
  sam_profile_flag?: boolean;

  gen_hour_profile_mw?: { timestamp: string; value: number | null }[];
};

export function buildProjectPayload(
  inputs: ModelInputs,
  overrides?: Partial<ProjectCreatePayload>
): ProjectCreatePayload {
  const raw: ProjectCreatePayload = {
    customer_id: inputs.customer_id,
    project_name: inputs.project_name,

    latitude: numOrUndef(inputs.latitude),
    longitude: numOrUndef(inputs.longitude),
    state: inputs.state || undefined,
    county: inputs.county || undefined,
    city: inputs.city || undefined,
    zip_code: inputs.zip_code || undefined,
    timezone: inputs.timezone || undefined,

    project_nerc_code: inputs.project_nerc_code || undefined,
    eia_ba_code: inputs.eia_ba_code || undefined,

    cod_date: toIsoDateOrUndef(inputs.cod_date),
    decommision_date: toIsoDateOrUndef(inputs.decommision_date),

    nameplate_capacity: numOrUndef(inputs.nameplate_capacity),
    poi_limit: numOrUndef(inputs.poi_limit),
    project_additional_load: numOrUndef(inputs.project_additional_load),

    ppa_flag: inputs.ppa_flag,
    ppa_percentage: numOrUndef(inputs.ppa_percentage),
    ppa_capacity: numOrUndef(inputs.ppa_capacity),

    battery_flag: inputs.battery_flag,
    battery_capacity_mwh: numOrUndef(inputs.battery_capacity_mwh),
    battery_charge_rate_mw: numOrUndef(inputs.battery_charge_rate_mw),
    battery_discharge_rate_mw: numOrUndef(inputs.battery_discharge_rate_mw),
    battery_round_trip_eff: numOrUndef(inputs.battery_round_trip_eff),
    battery_soc_min: numOrUndef(inputs.battery_soc_min),
    battery_chemistry: inputs.battery_chemistry || undefined,
    battery_calendar_life_years: numOrUndef(inputs.battery_calendar_life_years),
    battery_cycle_life: numOrUndef(inputs.battery_cycle_life),
    battery_augmentation_flag: inputs.battery_augmentation_flag,
    battery_depth_of_discharge: numOrUndef(inputs.battery_depth_of_discharge),

    tech_type_id: inputs.tech_type_id,
    existing_project_flag: inputs.existing_project_flag,
    sam_profile_flag: inputs.gen_hour_profile_mw.length > 0 ? false : !inputs.existing_project_flag,
  };

  if (inputs.gen_hour_profile_mw.length > 0) {
    raw.gen_hour_profile_mw = inputs.gen_hour_profile_mw;
  }

  return prune({ ...raw, ...overrides }) as ProjectCreatePayload;
}
